(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  // Collapsible functionality
  const collapsibleTriggers = document.querySelectorAll('.collapsible-trigger');
  
  collapsibleTriggers.forEach(trigger => {
    // Set initial state
    const isOpen = trigger.classList.contains('is-open');
    trigger.setAttribute('aria-expanded', isOpen);
    
    // Add click event
    trigger.addEventListener('click', toggleCollapsible);
  });
  
  function toggleCollapsible(e) {
    const trigger = e.currentTarget;
    const isOpen = trigger.classList.contains('is-open');
    const moduleId = trigger.getAttribute('aria-controls');
    const container = document.getElementById(moduleId);
    
    if (!container) return;
    
    const contentInner = container.querySelector('.collapsible-content__inner');
    const isAutoHeight = container.classList.contains('collapsible--auto-height');
    
    // Toggle aria-expanded
    trigger.setAttribute('aria-expanded', !isOpen);
    
    // Toggle classes
    if (isOpen) {
      trigger.classList.remove('is-open');
      container.classList.remove('is-open');
      
      // If auto-height, set height to 0 for closing animation
      if (isAutoHeight) {
        container.style.height = contentInner.offsetHeight + 'px';
        // Force reflow
        container.offsetHeight;
        container.style.height = '0px';
      } else {
        container.style.height = '0px';
      }
    } else {
      trigger.classList.add('is-open');
      container.classList.add('is-open');
      
      // If auto-height, set to actual height then auto
      if (isAutoHeight) {
        container.style.height = contentInner.offsetHeight + 'px';
        setTimeout(() => {
          container.style.height = 'auto';
        }, 300);
      } else {
        container.style.height = contentInner.offsetHeight + 'px';
      }
    }
    
    // Add transition end listener for auto-height containers
    if (isAutoHeight) {
      const handleTransitionEnd = () => {
        if (container.classList.contains('is-open')) {
          container.style.height = 'auto';
        }
        container.removeEventListener('transitionend', handleTransitionEnd);
      };
      
      container.addEventListener('transitionend', handleTransitionEnd);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obm-basket-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-obm-compare-choose]');
    if (!link) return;
    const section = document.querySelector('[id$="__main-product"]');
    const target = section?.querySelector('fieldset') || section?.querySelector('form[action*="/cart/add"]') || section;
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    const control = target.querySelector('input:not([type="hidden"]), select, button');
    control?.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obm-customer-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('.obm-stories').forEach(section => {
      if (section.dataset.obmReady) return;
      section.dataset.obmReady = 'true';
      const grid = section.querySelector('.obm-stories__grid');
      const nav = section.querySelector('.obm-stories__nav');
      if (!grid || !nav) return;
      const buttons = nav.querySelectorAll('button');
      const update = () => {
        nav.hidden = grid.scrollWidth <= grid.clientWidth + 2;
        buttons[0].disabled = grid.scrollLeft <= 2;
        buttons[1].disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = grid.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        grid.scrollBy({left: Number(button.dataset.obmDirection) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      grid.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(grid);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obm-duffle-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('obm-duffle-gallery')) {
    customElements.define('obm-duffle-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.obm-duffle-gallery__track');
        this.group = this.querySelector('.obm-duffle-gallery__group');
        this.viewport = this.querySelector('.obm-duffle-gallery__viewport');
        this.controls = this.querySelector('.obm-duffle-gallery__controls');
        this.button = this.querySelector('button');
        if (!this.group || !this.group.children.length) return;
        this.togglePause = () => {
          const paused = this.classList.toggle('is-paused');
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.querySelector('[data-pause]').hidden = paused;
          this.button.querySelector('[data-play]').hidden = !paused;
        };
        this.button.addEventListener('click', this.togglePause);
        this.observer = new ResizeObserver(() => this.resizeGallery());
        this.observer.observe(this.viewport);
        this.observer.observe(this.group);
        this.resizeGallery();
      }
      resizeGallery() {
        const distance = this.group.getBoundingClientRect().width;
        if (!distance) return;
        const copies = Math.ceil(this.viewport.clientWidth / distance) + 1;
        const clones = [...this.track.querySelectorAll('[data-gallery-clone]')];
        if (clones.length !== copies) {
          clones.forEach(clone => clone.remove());
          for (let index = 0; index < copies; index++) {
            const clone = this.group.cloneNode(true);
            clone.dataset.galleryClone = '';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach(photo => photo.removeAttribute('data-shopify-editor-block'));
            clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
            this.track.appendChild(clone);
          }
        }
        this.style.setProperty('--gallery-distance', `${distance}px`);
        this.style.setProperty('--gallery-duration', `${distance / 35}s`);
        this.classList.add('is-ready');
        this.controls.hidden = false;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.togglePause);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obm-duffle-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('.obm-stories').forEach(section => {
      if (section.dataset.obmReady) return;
      section.dataset.obmReady = 'true';
      const grid = section.querySelector('.obm-stories__grid');
      const nav = section.querySelector('.obm-stories__nav');
      if (!grid || !nav) return;
      const buttons = nav.querySelectorAll('button');
      const update = () => {
        nav.hidden = grid.scrollWidth <= grid.clientWidth + 2;
        buttons[0].disabled = grid.scrollLeft <= 2;
        buttons[1].disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = grid.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        grid.scrollBy({left: Number(button.dataset.obmDirection) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      grid.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(grid);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
